var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2831 27.5661C21.6191 27.5661 27.5661 21.6191 27.5661 14.2831C27.5661 6.94703 21.6191 1 14.2831 1C6.94703 1 1 6.94703 1 14.2831C1 21.6191 6.94703 27.5661 14.2831 27.5661Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5964 16.9388H14.2832V7.64062",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5058 32.8789H53.6009C54.7241 32.8788 55.7261 33.585 56.1035 34.6429L60.8455 47.926C61.1364 48.7413 61.0118 49.6473 60.5115 50.3538C60.0112 51.0603 59.1981 51.4788 58.3324 51.4752H55.2321",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6658 51.4763H43.5428L43.5189 27.5668C43.5189 26.0996 42.3295 24.9102 40.8623 24.9102H30.2358",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2832 32.8789V48.8186C14.2832 50.2858 15.4726 51.4752 16.9398 51.4752H21.1665",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4757 56.7882C53.6765 56.7882 55.4606 55.0041 55.4606 52.8033C55.4606 50.6025 53.6765 48.8184 51.4757 48.8184C49.2749 48.8184 47.4908 50.6025 47.4908 52.8033C47.4908 55.0041 49.2749 56.7882 51.4757 56.7882Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9094 56.7882C27.1102 56.7882 28.8944 55.0041 28.8944 52.8033C28.8944 50.6025 27.1102 48.8184 24.9094 48.8184C22.7086 48.8184 20.9245 50.6025 20.9245 52.8033C20.9245 55.0041 22.7086 56.7882 24.9094 56.7882Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 38.1934L8.96984 38.2066",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98482 43.5059L8.96974 43.5191",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6416 48.8184L8.96991 48.8316",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1172 40.8496H43.5058",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5351 51.4766H47.7379",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon-schedule.8b29bfae.svg";
export { ForwardRef as ReactComponent };